// @ts-ignore
 
import request from "src/lib/axios";

/** 手动刷新全部文件 OSS 签名 URL（与每日 0 点定时任务逻辑一致） POST /api/v1/admin/files/signature-urls/refresh */
export async function AdminFileControllerRefreshSignatureUrlsV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputFileSignatureRefreshDto>(
    "/api/v1/admin/files/signature-urls/refresh",
    {
      method: "POST",
      ...(options || {}),
    }
  );
}
